/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Document } from '../../core/models/Document';
import { Operation } from '../../core/models/common/Operation';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { DeleteNodeCommand } from './DeleteNodeCommand';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { OasOperation } from '../../openapi/models/OasOperation';

/**
 * A command used to delete an operation.
 * @author eric.wittmann@gmail.com
 * @extends DeleteNodeCommand
 * @class
 */
export class DeleteOperationCommand extends DeleteNodeCommand<Operation> {
    public constructor(opMethod? : any, pathItem? : any) {
        if(((typeof opMethod === 'string') || opMethod === null) && ((pathItem != null && pathItem instanceof <any>OasPathItem) || pathItem === null)) {
            let __args = arguments;
            super(opMethod, pathItem);
        } else if(opMethod === undefined && pathItem === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {Operation}
     */
    readNode(doc : Document, node : any) : Operation {
        let pathItem : OasPathItem = <OasPathItem>this._parentPath.resolve(doc);
        let operation : Operation = pathItem.createOperation(this._property);
        Library.readNode(node, operation);
        return operation;
    }
}
DeleteOperationCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteOperationCommand";
DeleteOperationCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




